import PropTypes from 'prop-types'
import React from 'react'

import styled from 'styled-components'

const CustomHeader = styled.header`
  line-height: 30px;
  align-items: center;
  text-align: center;
  margin: 0px 20px;
  @media (max-width: 909px) {
    margin-top: 70px;
  }
  h1 {
    color: white;
    margin-bottom: 10px;
  }
  p {
    max-width: 630px;
    color: #9FA1A2;
    margin-bottom: 30px;
  }
  .headerLinkSection {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 105px;
    a {
      white-space: nowrap;
      text-decoration: none;
      color: #6E60F9;
      font-weight: bold;
      margin: 0px 27px;
    }
  }
`

const Header = ({ header }) => (
  <CustomHeader>
    <h1>
      {header.title}
    </h1>
    {header.content}
    {header.links &&
      <div className='headerLinkSection'>
        {header.links.map((link, i) => {
          return <a href={link.href} target='_blank' rel='noopener noreferrer' key={i}>{link.text}</a>
        })}
      </div>}
  </CustomHeader>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
